<template>
	<span class="generic-menu-container">
		<template v-for="(node, index) in menuArray">
			<MenuItem
				:node="node"
				:key="index"
				@item-clicked="$emit('generic-menu-item-click')"/>
			<span class="link-separator" :key="index+'separator'" v-if="index !== menuArray.length - 1">|</span>
		</template>
	</span>
</template>

<script>
import MenuItem from './MenuItem.vue';

export default {
	name: 'GenericMenu',
	components: { MenuItem },
	props: {
		menuArray: {
			type: [Array, Object],
			required: true,
		},
	},
};
</script>

<style src="@/styles/components/GenericMenu/GenericMenu.less" lang="less" scoped></style>
